<script lang="ts">
  import { colorPlayOutcome, type PitchAtBatEvent } from '@statmuse/core/gamera'

  const mapXCoordinate = (x: number) => -1 * x * (61 / 100) + 491
  const mapYCoordinate = (y: number) => -1 * y * (72 / 100) + 191

  export let batterHandedness: string | undefined = undefined
  export let pitches: PitchAtBatEvent[]
</script>

<svg
  {...$$restProps}
  viewBox="0 0 982 412.9"
  xmlns="http://www.w3.org/2000/svg"
>
  <path
    d="m409.9 98.1h162.2v186h-162.2z"
    class="fill-gray-6 dark:fill-gray-5"
  />
  <g
    fill="none"
    class="stroke-gray-2 dark:stroke-gray-8"
    stroke-linecap="round"
    stroke-linejoin="round"
    stroke-width="2"
  >
    <path d="m430.2 118.3h40.5v48.5h-40.5z" />
    <path d="m470.7 118.3h40.5v48.5h-40.5z" />
    <path d="m511.3 118.3h40.5v48.5h-40.5z" />
    <path d="m430.2 166.8h40.5v48.5h-40.5z" />
    <path d="m470.7 166.8h40.5v48.5h-40.5z" />
    <path d="m511.3 166.8h40.5v48.5h-40.5z" />
    <path d="m430.2 215.3h40.5v48.5h-40.5z" />
    <path d="m470.7 215.3h40.5v48.5h-40.5z" />
    <path d="m511.3 215.3h40.5v48.5h-40.5z" />
  </g>
  <path
    d="m553.3 357.5h-124.6l-2.9 11.8 65.2 10.4 65.2-10.4z"
    class="fill-gray-5 dark:fill-gray-6"
  />
  <path
    d="m32.3 412.9 134.9-77.1h218.2l-45.2 77.1h27l36.5-81.7h-254.2l-147.9 81.7z"
    class="fill-gray-5 dark:fill-gray-6"
  />
  <path
    d="m641.8 412.9-45.3-77.1h218.3l134.8 77.1h30.7l-147.8-81.7h-254.2l36.5 81.7z"
    class="fill-gray-5 dark:fill-gray-6"
  />
  <clipPath id="batter-a"><path d="m188 .6h224.2v412.3h-224.2z" /></clipPath>
  <clipPath id="batter-b">
    <path
      d="m316.7 4.3s-3.5-1.6-7.8-1.6-10.3.3-15.1 1.1-9.9 3.4-14.5 8c-4.7 4.7-3.4 6.6-4.2 7.9s-.4.1-3.1 6.1c-2.7 5.9-3.1 8.6-3.2 11.3s-3 5.9-3.2 11.7 1 9.6-.4 21.2-1.6 22-1.6 22-1.6 1.4-1.4 6.6c.1 5.2-.3 8-.3 8s-4.8 2.4-5.1 7.5v2c-.1 0-2.8.8-1.1 4.7 1.8 3.9 5 5.4 5 5.4l14.3 13.2 43 16 5.2-4.9s3.9-.4 6-1.2.7-5.1.7-5.1.1-6.2 3.6-12.3 5.4-10.9 8.1-19.7 6.9-15.1 8.9-23.8c2-8.8 2-9 2-9s4.6 3.9 8.7 2.1 12.5-27.4 12.5-27.4-1.4-2.9-7.4-5.5-3.8-3.4-8.4-5.9-11.6-7.9-13.9-8.4l-5.1-6.3-22.2-24z"
    />
  </clipPath>
  <clipPath id="batter-c">
    <path
      d="m310.4 337.3v5.8s2.4 3.6 10.4 3.3 12.9-3.8 20.1-2.7c7.1 1.1 10.6 5.1 21.6 3.1s15.7-4.6 15-8.2-1.8-5.5-9-7.5-22.5-10.6-22.5-10.6l-21.9 9.7-13.6 7.1z"
    />
  </clipPath>
  <clipPath id="batter-d">
    <path
      d="m374.5 55.4s1.8-6 2.7-10.5c1.8-8.9.6-9.5-.2-17.9l6.5-2.7 8.4 4.6c2.4 14.2 3.1 17.2 4.7 25.4 1.5 8.3 2.6 12.5 1.2 21s-3.5 13.7-5.3 15.6c-2 2-5.6 4.2-14-.8s-17.2-5.7-22.1-13.3c0 0 .4-11.2 5.7-18.2s7.5-5.8 7.5-5.8 2.8-.2 5 2.7z"
    />
  </clipPath>
  <clipPath id="batter-e">
    <path
      d="m387.7 5c0-1.7-1.2-2.4-6.4-4.4-1.1-.4-7.2 5.2-7.2 5.2s-.6 4.7-.6 6.8 2.9 7 2.9 7-.9 2.7-.7 4.9 1.9 4.5 4.4 5.9 8.4 2.8 10.2 2.4 1.9-.6 2.1-2.6c.1-2 .2-2.1.5-2.7s4.5-5.1 4.5-5.1l3.8-14-10-6.8-3.4 3.3z"
    />
  </clipPath>
  <clipPath id="batter-f">
    <path
      d="m394 15c3.3 5.6 2.9 7.4 4.4 8s5-2.3 7.3-5.5 1.8-4.9-1.7-6.8-4.2-2.1-4.2-2.1l-5.7 6.4z"
    />
  </clipPath>
  <clipPath id="batter-g">
    <path
      d="m250.7 391.4c0 4.5-.4 10.3.6 11.9 1.1 1.6 5.6 3.2 18.5 2.7s14.4-2 18.5-.5c4 1.5 9 3.5 19.3 3.8 10.2.3 22.6-3.2 26.1-5.8s7.9-8.4 1.2-11.7c-6.7-3.4-12.4-6.1-20.3-9.4-7.9-3.4-16.2-8.5-16.2-8.5l-34.9 10.5-12.8 7.1z"
    />
  </clipPath>
  <clipPath id="batter-h">
    <path
      d="m260.6 126.4s-13.1 9.7-18.2 26.5.2 31.5 8.1 44 26.3 34 33 45c6.4 10.4 6.7 20 5.8 30.5 0 1.1-.5 2.1-1.3 2.9-3.2 3.6-12.4 15.3-15.7 34.2-4.1 23-8.5 32.3-13.9 48.1s-8.7 25.1-8.5 34.2c0 0 23.4 6.6 52-17.4 0 0-5.6-5.4-7.5-7.5s-2.9-1.2-2.9-1.2 3-1.9 1-4.7c0 0 2.6-.9 5.8-8.7 4.4-11.1 11.8-29.9 11.8-29.9l-.3 15.1s9.4 2.9 25.1-5.5 14.9-11.3 14.9-11.3-5.3-1.4-9.3-12c0 0 1.5-1.6 1.9-2.4s-.9-4.1-.9-12.5 3.2-20.2 6.1-30.9 5.5-11.7 3.5-22.5-5-21.6-9.5-38.6c-4.5-17.1-9.4-27-12.8-31.3s-4.9-5.6-4.9-6.8-.3-4.8-2.1-7.2l1.4-5.7s-9.9.9-34.2-11.1-28.2-13.2-28.2-13.2z"
    />
  </clipPath>
  <clipPath id="batter-i">
    <path
      d="m358.6 13.1c-5.8 4.8-11.6 12.7-18.2 16.7s-11.2 4.4-11.2 4.4-3.5 3.6-6.2 5.9c-2.8 2.3-4.9 3.4-9.9 3.8s-8.6-3.3-11-5.7-2.5-10-1.5-14.4 4.4-6.7 7.1-9.9 2.6-5.9 5-7.2 13-5.2 19.4-7.3 8.9-2.6 23.5-8c.8-.3-.7-1.3 1.7-3.6s5.1-2.9 7.2-4.8c2-2 4.2-4.2 6-3.2s2.8 2.4 5.3 2.8 2.3 2.8 3.7 3.8 4.1 3.1 5 4.7 1.4 2.6.5 4.6-2.2 4.1-5.6 6.4-2.8 1.3-4.5 3.3c-1.8 1.9-2.8 5.7-6.9 4.1-1.5-.6-2.9-1.2-2.9-1.2s-4.1 2.8-6.3 4.7z"
    />
  </clipPath>
  <clipPath id="batter-j">
    <path
      d="m355.5-8.4c3.8-.8 6.7-1.2 9.4.4s5.4 5.4 6.1 8.9-4.6 6-6.1 7.6 2.7 4.3 2.7 4.3l9.7-1.7 10.4-8.4 2.8-11.6-9.7-10.3-14.3-4.9-10.6 6-3.3 7.7z"
    />
  </clipPath>
  <clipPath id="batter-k">
    <path
      d="m401.8 6.3c.6-3.4-5.3-4.6-5.3-4.6-1.4-4.2-6.7-3.9-6.7-3.9-.9-2.4-2.7-1.9-5.2-1l-2.2-.4 1 2.4s-.3.1-.4 2.3c2.9 1.2 4.6 2.6 4.6 3.9s-.8 2.8-2.4 3.1c0 .3-.3 1.5.6 2.5 1.1 1.2 2.6.5 2.6.5s-1.2 1.4.6 2.5 3.2-.2 3.2-.2-.2.6.9 1.7 4.2-2.1 6.9-3.8 3.9-.7 3.9-.7c.5-2.4-2.2-4.4-2.2-4.4z"
    />
  </clipPath>
  <g
    clip-path="url(#batter-a)"
    transform-origin="center center"
    transform={`scale(${batterHandedness === 'left' ? '-1' : '1'}, 1)`}
  >
    <path
      d="m306.9 2.9c14.3-4.2 11.5-7.7 11.5-7.7h21.7l2.4 6.6-11.8 9.3-23-.3-.9-7.9z"
      fill="#303134"
      stroke="#221407"
      stroke-linejoin="round"
      stroke-width="1.5"
    />
    <path
      d="m316.7 4.3s-3.5-1.6-7.8-1.6-10.3.3-15.1 1.1-9.9 3.4-14.5 8c-4.7 4.7-3.4 6.6-4.2 7.9s-.4.1-3.1 6.1c-2.7 5.9-3.1 8.6-3.2 11.3s-3 5.9-3.2 11.7 1 9.6-.4 21.2-1.6 22-1.6 22-1.6 1.4-1.4 6.6c.1 5.2-.3 8-.3 8s-4.8 2.4-5.1 7.5v2c-.1 0-2.8.8-1.1 4.7 1.8 3.9 5 5.4 5 5.4l14.3 13.2 43 16 5.2-4.9s3.9-.4 6-1.2.7-5.1.7-5.1.1-6.2 3.6-12.3 5.4-10.9 8.1-19.7 6.9-15.1 8.9-23.8c2-8.8 2-9 2-9s4.6 3.9 8.7 2.1 12.5-27.4 12.5-27.4-1.4-2.9-7.4-5.5-3.8-3.4-8.4-5.9-11.6-7.9-13.9-8.4l-5.1-6.3-22.2-24z"
      fill="#909396"
    />
    <g clip-path="url(#batter-b)">
      <path
        d="m361.1 81.8c-3.7 1.8-5.3.2-4.7-5.1s5.5-1.2 5.5-1.2z"
        fill="#303134"
        stroke="#221407"
        stroke-linejoin="round"
        stroke-width="1.5"
      />
      <path
        d="m351.1 81.7c-4.5 11-3.4 10.6-8 19.5s-3.3 9.7-6.4 17-6.9 14.8-7.9 18.6c-.9 3.8-1.2 6.8-3.7-.3s-3.3-10.6-3.3-10.6-.4 2.8 1.4 9.3 4.7 8.4 3.8 10.9-4.1 4.7-4.1 4.7l5.4 4 13.9-12.8 15.6-53.6-6.8-6.7z"
        fill="#ebebeb"
      />
      <g fill="#303134">
        <path
          d="m275 19.8c-3.6 15.8-1.6 20.2 5.6 24.7 0 0-.5 1.3-5.1-1.7-4.6-3.1-6.3-2.6-5.1.9s3.1 6.7 7.1 7.8 10.2 1.6 10.2 1.6-6.6 2.5-12.7 0-4.5 7.8-7.2 17.9c-2.6 10.1-4.5 21.1-4.5 21.1s-1.1 3.1-1.3 5.3-1.6 6.3.7 4.4 5-3.3 9-6.2 6.9-6.5 6.9-6.5-2.1 7.3-7.6 13-8.1 4.2-10.5 9.9c-2.3 5.7-3 10.8-.3 14.3 2.8 3.5 12.5 2 19.9 5.4s26.3 15.8 27.3 11c.9-4.7-4.9-10-5.2-18.2s.8-11.6.8-11.6-.5 11.4 6.5 23.1 17.3 17.1 17.3 17.1l-7.1 6.3-66.8-16.6-5.9-60.5 13.3-42.7 14.5-20z"
        />
        <path
          d="m305.9 44.8c-7.6 3.2-10.1 3.1-12.4 4.2-2.3 1 3-.2 7.9-.8s-2.5 4-6.7 4.6-7.9 4.1 1.7 4 14 2.8 11.1 4.1-1.2 1.3-8.9 4.1c-7.6 2.8-2.8 12-12.2 26.4s-25.3 25.6-23.2 27.9c2.1 2.4 5.6 2.9 21.5-14.1 15.9-17.1 21.8-32.3 30.3-38.8s12-11.1 19.9-12.2 9.5-7.9 8.1-10.8-6.6-14.2-6.6-14.2l-24.9 3.6z"
        />
        <path
          d="m296.8 17.9c-1.7 7.3-1.7 10.9-.7 14.6s.9 5.8 2.8 7.5-2.2.9-4.2-2.1-2.8-4.9-2.5-11-2.7-7.2-4.6-1.6-.9 8.6-.9 8.6-1.3-6.3-.3-11.8c1.1-5.5.3-5.5 2.7-8.2s1-1 7-4.2 10.4-4.1 10.4-4.1-5.3 3.5-6.7 6.5-3.1 5.7-3.1 5.7z"
        />
      </g>
      <path
        d="m306.9 2.9c-8.2 1.5-6.8.8-12.2 2.8s-5.5.9-10.6 5.4-12 4.3-12 4.3l15.2-16.7 15 1 4.7 3.2z"
        fill="#ebebeb"
      />
      <path
        d="m344 34.7c5.8 5 1.1 4.3 8.7 9.3 7.6 4.9 19.3 7.8 19.3 7.8l-5.2-10.1-17.1-6.4z"
        fill="#ebebeb"
      />
    </g>
    <path
      d="m316.7 4.3s-3.5-1.6-7.8-1.6-10.3.3-15.1 1.1-9.9 3.4-14.5 8c-4.7 4.7-3.4 6.6-4.2 7.9s-.4.1-3.1 6.1c-2.7 5.9-3.1 8.6-3.2 11.3s-3 5.9-3.2 11.7 1 9.6-.4 21.2-1.6 22-1.6 22-1.6 1.4-1.4 6.6c.1 5.2-.3 8-.3 8s-4.8 2.4-5.1 7.5v2c-.1 0-2.8.8-1.1 4.7 1.8 3.9 5 5.4 5 5.4l14.3 13.2 43 16 5.2-4.9s3.9-.4 6-1.2.7-5.1.7-5.1.1-6.2 3.6-12.3 5.4-10.9 8.1-19.7 6.9-15.1 8.9-23.8c2-8.8 2-9 2-9s4.6 3.9 8.7 2.1 12.5-27.4 12.5-27.4-1.4-2.9-7.4-5.5-3.8-3.4-8.4-5.9-11.6-7.9-13.9-8.4l-5.1-6.3-22.2-24z"
      fill="none"
      stroke="#221407"
      stroke-linejoin="round"
      stroke-width="1.5"
    />
    <g fill="#221407">
      <path
        d="m256.7 117.1-.3-1.5c1.2-.2 2.9-2.5 4-4.4s1-1.3 1.7-1.7 0 0 0 0c.1.9 0 1.8-.6 2.6-1 1.7-3 4.6-4.9 5z"
      />
      <path
        d="m262.1 107.5-.7-1.3c1-.5 2.9-2.7 4.6-4.8 2.3-2.7 4.6-5.5 6.7-6.6 2.8-1.6 5.3-5 6.5-7.9.3-.8.8-1.6 1.5-2.1s0 0 0 0c.3 1 .2 2-.2 2.9-1.2 2.8-3.7 6.6-7 8.4-1.8 1-4.2 3.8-6.3 6.3-2 2.4-3.8 4.5-5.1 5.1z"
      />
      <path
        d="m264.1 92.5-1.3-.8c.6-1 1.1-1.5 1.5-1.9.8-.8 1.2-1.3 1.9-4.5.6-3 1.5-4.9 2.1-5.9.4-.8 1.2-1.3 2.1-1.6s0 0 0 0c0 .8-.3 1.5-.7 2.2s-1.4 2.7-2 5.6c-.7 3.5-1.2 4.2-2.2 5.2-.4.4-.8.9-1.4 1.7z"
      />
      <path
        d="m353.1 79.8-1.5-.2c.7-5.9-.3-19.7-2.6-30.3-.2-1-.2-2 0-2.9s0 0 0 0c.7.7 1.2 1.6 1.4 2.6 2.3 10.7 3.2 24.8 2.6 30.8z"
      />
      <path
        d="m344.3 94.4c-.2.8-.7 1.6-1.4 2.1s0 0 0 0c-.2-.8-.2-1.6 0-2.3.9-3.4 3.6-14.2 4-27.7.5-13.4-2.8-19.9-7.9-29.6-1.1-2.1-2.3-4.4-3.5-6.9l1.3-.7c1.2 2.5 2.4 4.7 3.5 6.8 4.9 9.6 8.5 16.5 8 30.3-.5 13.5-3.1 24.3-4.1 27.9z"
      />
      <path
        d="m332 68.6c-.2.9-.7 1.7-1.3 2.3s0 0 0 0c-.3-.8-.4-1.7-.2-2.6 2.8-12.5 3.3-19.2-1.5-35.3l1.4-.4c4.9 16.4 4.4 23.3 1.5 36.1z"
      />
      <path
        d="m328.6 65c-.2.9-.7 1.7-1.4 2.3s0 0 0 0c-.3-.9-.3-1.8 0-2.6 2.2-8.7 2.5-16.1-.9-29.9l1.5-.4c3.5 14 3.1 21.8.9 30.6z"
      />
      <path
        d="m298.2 105.4c-.6.7-1.5 1.2-2.4 1.3s0 0 0 0c.2-.8.6-1.6 1.2-2.2 5-5.3 15.9-20.7 22.2-32.9 5.7-11.1 5.3-18.7 4.8-29 0-1.8-.2-3.7-.2-5.7h1.5c0 1.9.2 3.8.2 5.6.5 10.6.9 18.3-5 29.8-6.4 12.5-17.1 27.5-22.3 33.1z"
      />
      <path
        d="m320 143.6c-.7-.1-1.3-.5-1.8-1.1-1.7-2.4-6.3-9.3-8.5-17.7-1.9-7 .4-13 4.3-22.9 1.8-4.6 4-10.3 6.3-17.5.3-.9.9-1.7 1.6-2.2s0 0 0 0c.2.8 0 1.7-.2 2.5-2.3 7.3-4.6 13.1-6.4 17.8-3.8 9.9-5.9 15.4-4.2 22 2.1 8.1 6.6 14.9 8.3 17.2.4.6.6 1.3.5 2s0 0 0 0z"
      />
      <path
        d="m305.5 62.5c-.8.3-1.8.4-2.6.3.5-.8 1.3-1.3 2.2-1.7 12.4-4.9 17.8-11.9 16.7-21.9l1.5-.2c1.1 10.8-4.5 18.3-17.7 23.5z"
      />
      <path
        d="m292.8 54c-.8 0-1.7-.2-2.4-.6.7-.6 1.5-.9 2.4-.9 11.9-.8 21.6-6.9 26.4-10.5l.9 1.2c-5 3.7-15 10-27.4 10.8z"
      />
      <path
        d="m289.5 14.8c-.4.8-1.1 1.4-1.9 1.9s0 0 0 0c0-.9.1-1.8.6-2.6 3.5-6.2 4.6-6.8 15.9-11.7l.6 1.4c-11.2 4.9-12 5.4-15.2 11.1z"
      />
      <path
        d="m276.4 51.6c-4.6-2-8.5-8.1-8.5-14.1h1.5c0 5.8 4 11.8 8.5 13.1s1.8.6 2.6 1.1h.1q0 0 0 0c-1.4.5-2.9.5-4.3-.1z"
      />
    </g>
    <path
      d="m310.4 337.3v5.8s2.4 3.6 10.4 3.3 12.9-3.8 20.1-2.7c7.1 1.1 10.6 5.1 21.6 3.1s15.7-4.6 15-8.2-1.8-5.5-9-7.5-22.5-10.6-22.5-10.6l-21.9 9.7-13.6 7.1z"
      fill="#303134"
    />
    <g clip-path="url(#batter-c)">
      <path
        d="m316.4 329.1c.7 9.7 5.8 11.1 15.7 11.1s12.1-.5 16.6 2.2c4.6 2.7 17.2 2.9 17.2 2.9v5.3l-51.7 1.5-8.2-9.7.9-8.2z"
        fill="#202124"
      />
      <path
        d="m346 320.5c6.4 8.2 6.8 6.9 13.2 9.7 6.4 2.7 16.8 3.5 18.3 8.4s6.8 4.4 6.8 4.4l-3.7-24.9-19-1.3-15.5 3.7z"
        fill="#ebebeb"
      />
    </g>
    <path
      d="m310.4 337.3v5.8s2.4 3.6 10.4 3.3 12.9-3.8 20.1-2.7c7.1 1.1 10.6 5.1 21.6 3.1s15.7-4.6 15-8.2-1.8-5.5-9-7.5-22.5-10.6-22.5-10.6l-21.9 9.7-13.6 7.1z"
      fill="none"
      stroke="#221407"
      stroke-linejoin="round"
      stroke-width="1.5"
    />
    <path
      d="m316 5.3s-1-.4-2.2-.6c0 0-8.5-1.1-14.5 8-6.1 9.2-4.4 24.2.9 28.6 5.4 4.4 13.2 7.3 20.9.2z"
      fill="#303134"
      stroke="#221407"
      stroke-linejoin="round"
      stroke-width="1.5"
    />
    <path
      d="m374.5 55.4s1.8-6 2.7-10.5c1.8-8.9.6-9.5-.2-17.9l6.5-2.7 8.4 4.6c2.4 14.2 3.1 17.2 4.7 25.4 1.5 8.3 2.6 12.5 1.2 21s-3.5 13.7-5.3 15.6c-2 2-5.6 4.2-14-.8s-17.2-5.7-22.1-13.3c0 0 .4-11.2 5.7-18.2s7.5-5.8 7.5-5.8 2.8-.2 5 2.7z"
      fill="#303134"
    />
    <g clip-path="url(#batter-d)">
      <path
        d="m383.6 32.3c1.8 12.7 3.2 13.7 1 23.5-2.1 9.9-2.8 10.5-1.5 21.6s8.7 15.7 1.9 16.3c-6.9.6-20-4.2-26-9.3s-7.6-20.6-6.3-24.9 1.3 1.7 8 10.6c14.6 19.2 14.1 3.3 14.3-5.8s-.8-9.2.7-13.3c1.4-4 2.1-9.3 2.3-12.8s-1-11.1-1-11.1.6 2.2 3.5 2.5 3.1 2.8 3.1 2.8z"
        fill="#202124"
      />
      <g fill="#ebebeb">
        <path
          d="m360.3 54.7c2-.3 11-.3 13.4 1 2.4 1.4-2.2-5.2-2.2-5.2l-12-1.6.7 5.8z"
        />
        <path
          d="m393.7 40.2c.4 12.5 1.5 11.7 1.8 19.9s1.1 11.5-.7 18.3c-1.7 6.8-1.1 7.6-3.5 14.2s10.2-4 10.2-4l1.7-35.7-3.3-13.2-6.3.5z"
        />
      </g>
    </g>
    <path
      d="m374.5 55.4s1.8-6 2.7-10.5c1.8-8.9.6-9.5-.2-17.9l6.5-2.7 8.4 4.6c2.4 14.2 3.1 17.2 4.7 25.4 1.5 8.3 2.6 12.5 1.2 21s-3.5 13.7-5.3 15.6c-2 2-5.6 4.2-14-.8s-17.2-5.7-22.1-13.3c0 0 .4-11.2 5.7-18.2s7.5-5.8 7.5-5.8 2.8-.2 5 2.7z"
      fill="none"
      stroke="#221407"
      stroke-linejoin="round"
      stroke-width="1.5"
    />
    <path
      d="m387.7 5c0-1.7-1.2-2.4-6.4-4.4-1.1-.4-7.2 5.2-7.2 5.2s-.6 4.7-.6 6.8 2.9 7 2.9 7-.9 2.7-.7 4.9 1.9 4.5 4.4 5.9 8.4 2.8 10.2 2.4 1.9-.6 2.1-2.6c.1-2 .2-2.1.5-2.7s4.5-5.1 4.5-5.1l3.8-14-10-6.8-3.4 3.3z"
      fill="#303134"
    />
    <g clip-path="url(#batter-e)" fill="#202124">
      <path
        d="m383 8.1c1.6.3 2.7 1.1 2.2 1.4s-1.5.5-3.2.2-3.1 1.1-3.4 3.4 1.7 5 3.6 6.6.8 3.7 5.7 5.1 8.6-3 9.1-2.5c2.1 1.9-4.7 6.9-4.7 6.9s-7.2-.4-11.5-4.7-4.4-5-5.5-6.4-2-8.3-2-8.3l.4-2.8 1.1-1.4 6.5 2z"
      />
      <path
        d="m375.6 22.1c3.8 4.5 2.6 4.9 7.2 6.4s6.5-.4 8.4-.3 2.6 3.6 2.6 3.6l-3.3 2.7-15.1-4.5-2-4.4 2.2-3.4z"
      />
    </g>
    <path
      d="m387.7 5c0-1.7-1.2-2.4-6.4-4.4-1.1-.4-7.2 5.2-7.2 5.2s-.6 4.7-.6 6.8 2.9 7 2.9 7-.9 2.7-.7 4.9 1.9 4.5 4.4 5.9 8.4 2.8 10.2 2.4 1.9-.6 2.1-2.6c.1-2 .2-2.1.5-2.7s4.5-5.1 4.5-5.1l3.8-14-10-6.8-3.4 3.3z"
      fill="none"
      stroke="#221407"
      stroke-linejoin="round"
      stroke-width="1.5"
    />
    <path
      d="m394 15c3.3 5.6 2.9 7.4 4.4 8s5-2.3 7.3-5.5 1.8-4.9-1.7-6.8-4.2-2.1-4.2-2.1l-5.7 6.4z"
      fill="#dacba8"
    />
    <g clip-path="url(#batter-f)">
      <path
        d="m395.5 13.2c1.1 4.4 3.4 5.9 4.4 5.2s1.8-2.7 3.8-3.3 4.9-1.4 1.9 2.4-7.1 8.4-7.1 8.4l-6.3-8.5 3.2-4.2z"
        opacity=".4"
      />
    </g>
    <path
      d="m394 15c3.3 5.6 2.9 7.4 4.4 8s5-2.3 7.3-5.5 1.8-4.9-1.7-6.8-4.2-2.1-4.2-2.1l-5.7 6.4z"
      fill="none"
      stroke="#221407"
      stroke-linejoin="round"
      stroke-width="1.5"
    />
    <path
      d="m380 2.2c2.3.5 4.8 1.3 5.4 2.4s2.2 1.9 2.2 1.2-.2-3.2-2.4-3.7-4-1.4-4-1.4l-1.3 1.5z"
      fill="#ebebeb"
    />
    <path
      d="m250.7 391.4c0 4.5-.4 10.3.6 11.9 1.1 1.6 5.6 3.2 18.5 2.7s14.4-2 18.5-.5c4 1.5 9 3.5 19.3 3.8 10.2.3 22.6-3.2 26.1-5.8s7.9-8.4 1.2-11.7c-6.7-3.4-12.4-6.1-20.3-9.4-7.9-3.4-16.2-8.5-16.2-8.5l-34.9 10.5-12.8 7.1z"
      fill="#303134"
    />
    <g clip-path="url(#batter-g)">
      <path
        d="m295.1 376.1c19.1 11.7 17.9 10.6 27.8 13.9s13.6 3.5 13.3 6.5-3.9 7.7-7.8 10 7.1 2 7.1 2l9.7-15.1-29.5-22.4-15.2-3.4z"
        fill="#ebebeb"
      />
      <path
        d="m297.5 378.8c-5.9 9-13.5 12.6-19.5 15.5s-7.5 7.2-5.8 10.5-6.1 5.6-6.1 5.6l-17.8-3-1.3-21.6 35.3-14.7 19.1-2.1 3.4 2.9-7.2 6.8z"
        fill="#202124"
      />
    </g>
    <path
      d="m250.7 391.4c0 4.5-.4 10.3.6 11.9 1.1 1.6 5.6 3.2 18.5 2.7s14.4-2 18.5-.5c4 1.5 9 3.5 19.3 3.8 10.2.3 22.6-3.2 26.1-5.8s7.9-8.4 1.2-11.7c-6.7-3.4-12.4-6.1-20.3-9.4-7.9-3.4-16.2-8.5-16.2-8.5l-34.9 10.5-12.8 7.1z"
      fill="none"
      stroke="#221407"
      stroke-linejoin="round"
      stroke-width="1.5"
    />
    <path
      d="m260.6 126.4s-13.1 9.7-18.2 26.5.2 31.5 8.1 44 26.3 34 33 45c6.4 10.4 6.7 20 5.8 30.5 0 1.1-.5 2.1-1.3 2.9-3.2 3.6-12.4 15.3-15.7 34.2-4.1 23-8.5 32.3-13.9 48.1s-8.7 25.1-8.5 34.2c0 0 23.4 6.6 52-17.4 0 0-5.6-5.4-7.5-7.5s-2.9-1.2-2.9-1.2 3-1.9 1-4.7c0 0 2.6-.9 5.8-8.7 4.4-11.1 11.8-29.9 11.8-29.9l-.3 15.1s9.4 2.9 25.1-5.5 14.9-11.3 14.9-11.3-5.3-1.4-9.3-12c0 0 1.5-1.6 1.9-2.4s-.9-4.1-.9-12.5 3.2-20.2 6.1-30.9 5.5-11.7 3.5-22.5-5-21.6-9.5-38.6c-4.5-17.1-9.4-27-12.8-31.3s-4.9-5.6-4.9-6.8-.3-4.8-2.1-7.2l1.4-5.7s-9.9.9-34.2-11.1-28.2-13.2-28.2-13.2z"
      fill="#909396"
    />
    <g clip-path="url(#batter-h)">
      <path
        d="m246.1 136.1c38.2 11 42.9 12 50.5 15.9 7.5 3.9 19.1 9.3 25.1 4.5l5.6-3.7-1.1-8.4-66.1-23.2-12.5 8.8-1.5 6z"
        fill="#303134"
      />
      <path
        d="m327 200.4c-2.8 15.9.5 23.8 2.6 31.5 2.1 7.6 5.1 8.5 4.7 18.9s.1 16.9-5.1 26.8-9.5 12.8-17.9 34c-8.5 21.2-13.1 33.7-15.4 40.1s-1.2 5.8-6 9-5.5 5-5.5 5l8.1-4.7s1.6.5-3 4.1-8.3 7.5-8.3 7.5 9.5-6.4 9.8-6.4 4.6 4.3 6.2 6.7 1.9 3.8 1.9 3.8l18 3.2-8.9-44.7-.2-.8.6-4.1 1-7.1.4 12.1.4 1.8s8.5 2.9 20-2.8 16.7-10.3 16.7-10.3-8.5-9.3-9.4-12.6c0 0-7.7 4.9-10.8 7.1s3.4-3.6 6.6-6.7 5.9-4.4 6-7.9c0-3.5-2.5-3.8-1.6-18.3s5-20.7 7.7-33.8c2.7-13.2 2.3-14.5-3.2-36.6-5.4-22-11.3-35.8-16.7-42s-7.2-9.4-6.7-11.9.2-9.8.2-9.8l15 4.2 29.5 75.3 19 110.6-57.5 13.2s-9.9-4.9-13.7-11.9-2.2-7.7-2.2-12.2.8-10.9 3.7-16.1 8.4-21 12.6-25.6 10.2-15.7 11-22.2 1.1-12.7.8-19.1-3.3-14-4.9-18.7-4.4-13.3-4.5-17.6-1.1-11.1-1.1-11.1z"
        fill="#ebebeb"
      />
      <g fill="#303134">
        <path
          d="m328.2 200.8c1.2 13.5 3.6 15.1 6.1 20.9 2.5 5.9 4.3 15.7 4.7 24.9s.4 15.8-1.7 24.1-8.2 16.1-11.8 26c-3.6 9.8-5.6 10.9-5.1 14.9s5.5 0 8.9-1.6-3.1 3.4-7.8 7-10.1 12.3-6.9 12.3 10.1-2.7 15.4-5.7 6.6-1.4-.7 2.8-10.1 10.9-10.1 10.9l-9.5 3s.1-8.9.4-14.3 4.3-17.2 7.3-22.6 10.3-16.5 13.2-21.4 5.5-9.2 6.2-14.3c.6-5.1.9-17 .9-21.4s-3.2-14.3-4.9-17.8-4.4-12.3-4.7-17.1c-.2-4.8 0-10.7 0-10.7z"
        />
        <path
          d="m244.5 185.8c14.5 13.4 15.7 13.6 20 17.7s23.2 18.3 39.2 21.8c0 0-6 1.2-12.8-1.6 0 0 8.4 7.5 16.8 10.5 0 0-12.1-2.5-20.4-7.1 0 0-4 9.5 9.3 22s-4.5-2-6.9-4.3 2.7 9.9 7.9 16-3.7 16.3-8.7 22.4 2.3 6.3 8.5 4.4c6.3-1.9 4.5-1.1 1.3.9s-9.6 2-11.5 2.4-3.1.1-6.5 10.9c-3.5 10.8-7.5 30.1-12.8 41s-10.4 43.6-7.9 49.4-16 3.8-16 3.8l-.3-51.7 18.5-106.4-17.9-52.3z"
        />
      </g>
    </g>
    <path
      d="m260.6 126.4s-13.1 9.7-18.2 26.5.2 31.5 8.1 44 26.3 34 33 45c6.4 10.4 6.7 20 5.8 30.5 0 1.1-.5 2.1-1.3 2.9-3.2 3.6-12.4 15.3-15.7 34.2-4.1 23-8.5 32.3-13.9 48.1s-8.7 25.1-8.5 34.2c0 0 23.4 6.6 52-17.4 0 0-5.6-5.4-7.5-7.5s-2.9-1.2-2.9-1.2 3-1.9 1-4.7c0 0 2.6-.9 5.8-8.7 4.4-11.1 11.8-29.9 11.8-29.9l-.3 15.1s9.4 2.9 25.1-5.5 14.9-11.3 14.9-11.3-5.3-1.4-9.3-12c0 0 1.5-1.6 1.9-2.4s-.9-4.1-.9-12.5 3.2-20.2 6.1-30.9 5.5-11.7 3.5-22.5-5-21.6-9.5-38.6c-4.5-17.1-9.4-27-12.8-31.3s-4.9-5.6-4.9-6.8-.3-4.8-2.1-7.2l1.4-5.7s-9.9.9-34.2-11.1-28.2-13.2-28.2-13.2z"
      fill="none"
      stroke="#221407"
      stroke-linejoin="round"
      stroke-width="1.5"
    />
    <path
      d="m280.4 374.3c-.7.4-1.6.6-2.4.5.4-.8 1-1.4 1.7-1.9 4.5-2.6 8.3-5.2 11.4-7.7l1 1.2c-3.1 2.6-7 5.2-11.6 7.9z"
      fill="#221407"
    />
    <path
      d="m283.5 367.2c-.7.6-1.6 1.1-2.6 1.4s0 0 0 0c.3-1 .9-2 1.8-2.7s2.7-2.2 4.8-3.4c3.5-2 4.7-2.1 4.9-2.1v1.5s0-.8 0-.8v.7s-.9.1-4.2 2c-2.1 1.2-3.8 2.5-4.8 3.4z"
      fill="#221407"
    />
    <path
      d="m310.8 322.7-1.4-.5c3.4-9.3 8.7-22.7 14.5-31.4.6-.9 1.3-1.9 1.9-2.9 5.3-7.7 10.7-15.7 11.1-27 .4-12.8-.2-19-4.4-30.2-4.6-12.3-6.4-22.2-5.5-30.2s.6-2.2 1.3-3.1 0 .2 0 .2c.3.9.3 1.8.2 2.7-1 7.9.8 17.7 5.4 29.9 4.3 11.5 4.9 17.7 4.5 30.8-.4 11.7-5.9 19.9-11.3 27.8-.6 1-1.3 1.9-1.9 2.8-5.7 8.6-10.9 21.9-14.3 31.1z"
      fill="#221407"
    />
    <path
      d="m321.5 323.3c-.7.7-1.6 1.1-2.5 1.4s0 0 0 0c.3-1 .8-1.8 1.6-2.5 2.8-2.5 6.6-4.9 9.1-6.3l.9-.5c4.2-2.6 7.3-4.9 9.3-7l1.1 1c-2.1 2.2-5.3 4.5-9.6 7.2l-.9.5c-2.4 1.5-6.2 3.8-8.9 6.2z"
      fill="#221407"
    />
    <path
      d="m358.6 13.1c-5.8 4.8-11.6 12.7-18.2 16.7s-11.2 4.4-11.2 4.4-3.5 3.6-6.2 5.9c-2.8 2.3-4.9 3.4-9.9 3.8s-8.6-3.3-11-5.7-2.5-10-1.5-14.4 4.4-6.7 7.1-9.9 2.6-5.9 5-7.2 13-5.2 19.4-7.3 8.9-2.6 23.5-8c.8-.3-.7-1.3 1.7-3.6s5.1-2.9 7.2-4.8c2-2 4.2-4.2 6-3.2s2.8 2.4 5.3 2.8 2.3 2.8 3.7 3.8 4.1 3.1 5 4.7 1.4 2.6.5 4.6-2.2 4.1-5.6 6.4-2.8 1.3-4.5 3.3c-1.8 1.9-2.8 5.7-6.9 4.1-1.5-.6-2.9-1.2-2.9-1.2s-4.1 2.8-6.3 4.7z"
      fill="#303134"
    />
    <g clip-path="url(#batter-i)">
      <path
        d="m308.2 45.2c.8-11.6 2.3-11.2 7.2-13.3s12.4-.3 17.2-4.7 8.9-9.9 12.7-9.3 11.9-5.4 11.8-6.9-.6-2.1-6.4-3.5-6.5-3.3-6.5-3.3 6.6 1.9 12.1 2.6c5.6.6 7.3 0 8.9-2.2s5.6-1.6 5.6-1.6c2.7.3 4.2.1 7.5-2.8 3.2-2.9 2.5-3.1 3.5-5.6s5.7-2.1 5.7-2.1l-3 8.8-13 18.2-32.4 24-20.7 3.5-10.1-1.8z"
        fill="#202124"
      />
      <path
        d="m355.5-8.4c3.8-.8 6.7-1.2 9.4.4s5.4 5.4 6.1 8.9-4.6 6-6.1 7.6 2.7 4.3 2.7 4.3l9.7-1.7 10.4-8.4 2.8-11.6-9.7-10.3-14.3-4.9-10.6 6-3.3 7.7z"
        fill="#303134"
      />
      <g clip-path="url(#batter-j)">
        <path
          d="m305.4 43.9c.8-11.6 5-15.6 9.9-17.7s9.1-2.4 13.9-6.8 12.1-5.4 15.9-4.8 12.1-2.2 11.9-3.8-.6-2.1-6.4-3.5-6.5-3.3-6.5-3.3 6.6 1.9 12.1 2.6c5.6.6 7.3 0 8.9-2.2s5.6-1.6 5.6-1.6c2.7.3 4.2.1 7.5-2.8 3.2-2.9 2.5-3.1 3.5-5.6s5.7-2.1 5.7-2.1l-3 8.8-13 18.2-32.4 24-20.7 3.5-12.8-3z"
          fill="#202124"
        />
      </g>
      <path
        d="m355.5-8.4c3.8-.8 6.7-1.2 9.4.4s5.4 5.4 6.1 8.9-4.6 6-6.1 7.6 2.7 4.3 2.7 4.3l9.7-1.7 10.4-8.4 2.8-11.6-9.7-10.3-14.3-4.9-10.6 6-3.3 7.7z"
        fill="none"
        stroke="#221407"
        stroke-linejoin="round"
        stroke-width="1.5"
      />
      <path
        d="m302 16.7c13.5-2 15.4-6.4 21.3-10.1s16.2-7.1 19.1-7.2 5.6-.2 6.5.2c0 0-.4-1.3-1.5-1.6s.4-.9 4.1-1.1c3.6-.3 3.1-.1 4.3-.2s-.9-.7-2.2-1.2 2.9-1.4 5-2.3-.2-2.5 3.6-5.6 4.5-4.8 6.5-5.1 3.5.9 5.5 2.1-.8.9 3.6 3.2 7.7 2.7 7.7 2.7l-6.4-10.6-12.3-3-38 14.2-21.8 12.4-4.9 13.3z"
        fill="#ebebeb"
      />
      <path
        d="m355.5-8.4c3.8-.8 6.7-1.2 9.4.4s5.4 5.4 6.1 8.9-4.6 6-6.1 7.6 2.7 4.3 2.7 4.3l9.7-1.7 10.4-8.4 2.8-11.6-9.7-10.3-14.3-4.9-10.6 6-3.3 7.7z"
        fill="none"
        stroke="#221407"
        stroke-linejoin="round"
        stroke-width="1.5"
      />
    </g>
    <path
      d="m358.6 13.1c-5.8 4.8-11.6 12.7-18.2 16.7s-11.2 4.4-11.2 4.4-3.5 3.6-6.2 5.9c-2.8 2.3-4.9 3.4-9.9 3.8s-8.6-3.3-11-5.7-2.5-10-1.5-14.4 4.4-6.7 7.1-9.9 2.6-5.9 5-7.2 13-5.2 19.4-7.3 8.9-2.6 23.5-8c.8-.3-.7-1.3 1.7-3.6s5.1-2.9 7.2-4.8c2-2 4.2-4.2 6-3.2s2.8 2.4 5.3 2.8 2.3 2.8 3.7 3.8 4.1 3.1 5 4.7 1.4 2.6.5 4.6-2.2 4.1-5.6 6.4-2.8 1.3-4.5 3.3c-1.8 1.9-2.8 5.7-6.9 4.1-1.5-.6-2.9-1.2-2.9-1.2s-4.1 2.8-6.3 4.7z"
      fill="none"
      stroke="#221407"
      stroke-linejoin="round"
      stroke-width="1.5"
    />
    <path
      d="m401.8 6.3c.6-3.4-5.3-4.6-5.3-4.6-1.4-4.2-6.7-3.9-6.7-3.9-.9-2.4-2.7-1.9-5.2-1l-2.2-.4 1 2.4s-.3.1-.4 2.3c2.9 1.2 4.6 2.6 4.6 3.9s-.8 2.8-2.4 3.1c0 .3-.3 1.5.6 2.5 1.1 1.2 2.6.5 2.6.5s-1.2 1.4.6 2.5 3.2-.2 3.2-.2-.2.6.9 1.7 4.2-2.1 6.9-3.8 3.9-.7 3.9-.7c.5-2.4-2.2-4.4-2.2-4.4z"
      fill="#303134"
    />
    <g clip-path="url(#batter-k)">
      <path
        d="m387.7 5c1.9 1.6 2.9 1.4 2.1 3.2s-1.9 2.8-1.4 3.9.6-.3 2.6-2 5-1.8 5-1.8-2.7 2.3-3 4.3l-.3 1.9s0-1.4 3.4-2.8c3.5-1.4 4.6-.6 4.6-.6l-.6 4-6.2 2.9-9.9-6.1 1.3-4 2.1-1.7.3-1.4z"
        fill="#202124"
      />
      <path
        d="m383.5-1.2c2.7-.5 3.8-1.1 4.8-.5l1 .6s2-.7 3.5 1.3 2.3 2.6 2.3 2.6 3 .2 3.9 1.5c1 1.4.7 2.3.7 2.3s2.7 1.3 2.6 3.7 1.1 3.4 1.1 3.4l2.5-2-.5-8.8-14.9-10.6-10.5 1.1-.4 5.7 3.6-.3z"
        fill="#ebebeb"
      />
      <g
        fill="none"
        stroke="#221407"
        stroke-linejoin="round"
        stroke-width="1.5"
      >
        <path d="m389.9-2.2c-1.5 2.4-2.4 4-3 5.3" />
        <path d="m388.5 11.1c2.3-4.9 8-9.5 8-9.5" />
        <path d="m392.3 13.5c3-4.2 4.9-5.7 6.2-6.5s3.3-.7 3.3-.7" />
      </g>
    </g>
    <path
      d="m401.8 6.3c.6-3.4-5.3-4.6-5.3-4.6-1.4-4.2-6.7-3.9-6.7-3.9-.9-2.4-2.7-1.9-5.2-1l-2.2-.4 1 2.4s-.3.1-.4 2.3c2.9 1.2 4.6 2.6 4.6 3.9s-.8 2.8-2.4 3.1c0 .3-.3 1.5.6 2.5 1.1 1.2 2.6.5 2.6.5s-1.2 1.4.6 2.5 3.2-.2 3.2-.2-.2.6.9 1.7 4.2-2.1 6.9-3.8 3.9-.7 3.9-.7c.5-2.4-2.2-4.4-2.2-4.4z"
      fill="none"
      stroke="#221407"
      stroke-linejoin="round"
      stroke-width="1.5"
    />
    <path
      d="m382 8.5c-.2 0-.4 0-.6-.2-.9-.2-1.6-.8-2.1-1.6.7-.2 1.5-.2 2.2 0 1.1.3 1.9.4 3.9.6v1.5c-1.6-.1-2.5-.2-3.4-.4z"
      fill="#221407"
    />
    <path
      d="m376.3 19.6c4.4 4.8 8 7.9 16 9.5"
      fill="none"
      stroke="#221407"
      stroke-linejoin="round"
      stroke-width="1.5"
    />
    <path
      d="m376.5 63.9c0 1-.4 1.9-.9 2.7s0 0 0 0c-.4-.8-.6-1.7-.6-2.6s0-1.1 0-1.9c0-.9-.2-1.7-.5-2.7-.4-1.3-.8-2.8-.8-4.9h1.5c0 1.9.4 3.3.7 4.5.3 1 .5 2 .6 3.1z"
      fill="#221407"
    />
  </g>
  {#each pitches as p, index (p)}
    <circle
      r="18"
      class={colorPlayOutcome(p)}
      cx={mapXCoordinate(p.pitchData?.coordinates?.x ?? 0)}
      cy={mapYCoordinate(p.pitchData?.coordinates?.y ?? 0)}
    />
    <text
      font-size="22"
      fill="white"
      text-anchor="middle"
      x={mapXCoordinate(p.pitchData?.coordinates?.x ?? 0)}
      y={mapYCoordinate(p.pitchData?.coordinates?.y ?? 0) + 7.5}
    >
      {index + 1}
    </text>
  {/each}
</svg>
